import React from 'react';

import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faComment, faHeart, faShare, faTrash, faEllipsisV, faEdit, faRetweet } from '@fortawesome/free-solid-svg-icons';
import { faHeart as farHeart } from '@fortawesome/free-regular-svg-icons';
import { openReference, timeAgo } from '../utils/functions';
import { Dropdown } from 'react-bootstrap';
import VerseImageGenerator from './VerseImageGenerator';
import { backendUrl } from '../utils/variables';

export default function Insight ({ share, insight, setReference, toggle_like, setInsight, type, delete_insight=false, edit_insight, mode="", userId, onRepost})  {

    const p_url = "https://clowza.com";

    const navigate = useNavigate();

    const open_ref = async (ref) => {


        const ref_ = await openReference(ref)

        if(ref_){
           
            setReference(ref_)
        }

    } 


    const goto_insight = (insight) =>{
        
        setInsight(insight)
       
        navigate(`/${insight.username}/insight/${insight.id}`)

    }

    const doRepost = async () => {
        if (!userId) return;

        try {
            const response = await fetch(`${backendUrl}/repost_insight.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_id: userId,
                    insight_id: insight.id,
                }),
            });
            const data = await response.json();
            if (data.success && onRepost) {
                onRepost(insight.id, !!data.repost, parseInt(data.total_reposts, 10) || 0);
            }
        } catch (error) {
            console.error('Error reposting insight:', error);
        }
    };


    

    const isRepost = Number(insight.is_repost) === 1 && !!insight.reposted_by_username;

    return(

    <div key ={insight.feed_key || insight.id} className="mb-4 pb-4 border-bottom">

    <div className="d-flex">

      <div className="me-3" style={{ width: 40, flexShrink: 0 }} onClick={()=> navigate(`/${insight.username}`)}>
        <img src={insight.photo || `${process.env.PUBLIC_URL}/avatar.jpg`} alt="Profile" className="rounded-circle" />
      </div>

      <div className="w-100 ">
      
      {isRepost && (
        <div className="d-flex align-items-center mb-1" style={{ gap: 6 }}>
          <FontAwesomeIcon icon={faRetweet} className="sc-text-muted" style={{ fontSize: '0.85rem' }} />
          <span className="sc-text-muted" style={{ fontSize: 'smaller' }}>@{insight.reposted_by_username} reposted</span>
        </div>
      )}

      <div className="d-flex align-items-center">

        <span className="fw-bold me-2">{insight.name}</span>
        <span className="sc-text-muted me-2" onClick={() => goto_insight(insight)}>{`@${insight.username}`}</span>
        <span className="sc-text-muted">{timeAgo(insight.time_posted)}</span>

        {type === "mine" && Number(insight.is_repost) !== 1 && (

          <Dropdown className="ms-auto">
            <Dropdown.Toggle variant="link link-dark" bsPrefix="p-0">
              <FontAwesomeIcon icon={faEllipsisV} />
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
              <Dropdown.Item onClick={() => edit_insight(insight)}>
                <FontAwesomeIcon icon={faEdit} className="me-2" />
                Edit
              </Dropdown.Item>
              <Dropdown.Item onClick={() => delete_insight(insight.id)} >
                <FontAwesomeIcon icon={faTrash} className="me-2" />
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
   
  
        {insight.passages.length >  5 && 
        
        <div className="d-flex_ justify-content-between sc-text-muted my-2" >
  
            {JSON.parse(insight.passages).map((ref, index) => (
  
            <span key={index} className="b-primary ref-btn" style={{ display: 'inline-block', padding: '0px 5px', margin: '2px 0',  alignItems: 'center', marginRight:'15px', borderRadius:'7px' }}>
  
                  <span  onClick={() => open_ref(ref)} style={{color:'white'}}>  {ref.book} {ref.chapter}:{ref.verse1}{`${parseInt(ref.verse2) > parseInt(ref.verse1)? `-${ref.verse2}` : ''}`}</span>
  
                <FontAwesomeIcon
                    icon={faBook}
                    style={{ cursor: 'pointer', color: 'white' , marginLeft:'10px', fontSize:'smaller'}}
                />
            </span>
            ))}
        </div>
       }
  
        {insight.passages && JSON.parse(insight.passages).length > 0 && (
          <div className="my-3">
            <VerseImageGenerator 
              passages={JSON.parse(insight.passages)} 
              url={`clowza.com/${insight.username}/insight/${insight.id}`}
              gradientIndex={insight.gradient_index || Math.floor(Math.random() * 20)}
            />
          </div>
        )}
  
        <div className="mt-2" onClick={()=> goto_insight(insight)}>
          <p dangerouslySetInnerHTML={{ __html: `${insight.insight.length < 150 ? insight.insight : insight.insight.substring(0,150)+" ...<b>read more</b>" }` }} />
        </div>
  
    
        {mode !== "search" && <div className="d-flex justify-content-between sc-text-muted mt-2 insight-icons-div ">
          <span> <FontAwesomeIcon icon={faComment}  onClick={() => goto_insight(insight)} /> {insight.total_comments}</span>
          <span onClick={()=>toggle_like(insight.id, type)}> <FontAwesomeIcon style={{color: insight.user_liked > 0 ? '#48887b': 'unset'}} icon={insight.user_liked > 0 ? faHeart : farHeart} /> {insight.total_likes}</span>
          <span onClick={doRepost}> <FontAwesomeIcon style={{color: insight.user_reposted > 0 ? '#48887b': 'unset'}} icon={faRetweet} /> {insight.total_reposts || 0}</span>
          <span onClick={()=>share( `${p_url}/${insight.username}/insight/${insight.id}`)}> <FontAwesomeIcon icon={faShare} /> {'Share'}</span>
        </div>}

      </div>
    </div>
    </div>
    )
};
  
